import { ALIYUN_CAPTCHA_ID } from './aliyunCaptchaConfig'

let captchaObj = null
let initPromise = null
let pendingResolve = null
let pendingReject = null

function normalizeCaptchaResult(result) {
  if (!result || typeof result !== 'object') {
    return null
  }
  const normalized = {
    lot_number: result.lot_number || result.lotNumber || '',
    captcha_output: result.captcha_output || result.captchaOutput || '',
    pass_token: result.pass_token || result.passToken || '',
    gen_time: result.gen_time != null ? String(result.gen_time) : (result.genTime != null ? String(result.genTime) : '')
  }
  if (!normalized.lot_number || !normalized.captcha_output || !normalized.pass_token || !normalized.gen_time) {
    return null
  }
  return normalized
}

function ensureCaptchaObj() {
  if (initPromise) {
    return initPromise
  }

  if (typeof window.initAlicom4 !== 'function') {
    return Promise.reject(new Error('图形验证 SDK 未加载，请检查 ct4.js'))
  }

  if (!ALIYUN_CAPTCHA_ID) {
    return Promise.reject(new Error('未配置图形验证 appId，请在 aliyunCaptchaConfig.js 中填写'))
  }

  initPromise = new Promise((resolve, reject) => {
    window.initAlicom4({
      captchaId: ALIYUN_CAPTCHA_ID,
      product: 'bind',
      language: 'zho'
    }, (obj) => {
      captchaObj = obj

      obj.onSuccess(() => {
        const result = normalizeCaptchaResult(obj.getValidate())
        if (result && pendingResolve) {
          pendingResolve(result)
        } else if (pendingReject) {
          obj.reset()
          pendingReject(new Error('图形验证失败，请重试'))
        }
        pendingResolve = null
        pendingReject = null
      })

      obj.onError(() => {
        if (pendingReject) {
          pendingReject(new Error('图形验证加载失败，请稍后重试'))
        }
        pendingResolve = null
        pendingReject = null
      })

      obj.onClose(() => {
        if (pendingReject) {
          pendingReject(new Error('CAPTCHA_CANCEL'))
        }
        pendingResolve = null
        pendingReject = null
      })

      resolve(obj)
    })
  }).catch((err) => {
    initPromise = null
    throw err
  })

  return initPromise
}

/**
 * 弹出阿里云图形验证，成功后返回二次校验参数
 * @returns {Promise<{lot_number, captcha_output, pass_token, gen_time}>}
 */
export function showAliyunCaptcha() {
  return ensureCaptchaObj().then((obj) => {
    return new Promise((resolve, reject) => {
      pendingResolve = resolve
      pendingReject = reject
      obj.showCaptcha()
    })
  })
}



// WEBPACK FOOTER //
// ./src/js/aliyunCaptcha.js